// extracted by mini-css-extract-plugin
export default {"main":"TarifaSelector_main__4u2Rb"};